// extracted by mini-css-extract-plugin
export default {"moveUpDown":"shapes-backdrop_moveUpDown__evFTn"};